module.exports = __webpack_public_path__ + "static/media/exitblue.71fcdca3.svg";